<template>
  <div id="app">
    <router-view name="header" />
    <router-view name="body" />
    <router-view name="footer" />
  </div>
</template>

<script>
export default {
  metaInfo: {
    titleTemplate: "%s | Huahed Krob",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "description", content: "I have things here on my site." },

      // OpenGraph
      { property: "og:title", content: "Huahed Krob" },
      { property: "og:site_name", content: "HuahedKrob" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://huahedkrob.com" },
      { property: "og:image", content: require("@images/logo.png") },
      { property: "og:description", content: "I have things here on my site." },

      // Twitter card
      { name: "twitter:card", content: "summary" },
      { name: "twitter:site", content: "https://huahedkrob.com" },
      { name: "twitter:title", content: "Huahed Krob" },
      {
        name: "twitter:description",
        content: "I have things here on my site."
      },
      { name: "twitter:creator", content: "@Vasin" },
      {
        name: "twitter:image:src",
        content: require("@images/logo.png")
      },

      // Google / Schema.org markup:
      { itemprop: "name", content: "Huahed Krob" },
      { itemprop: "description", content: "I have things here on my site." },
      {
        itemprop: "image",
        content: require("@images/logo.png")
      }
    ]
  }
};
</script>


<style lang="scss">
@import "https://fonts.googleapis.com/css?family=Sriracha&display=swap";
@import "https://fonts.googleapis.com/css?family=Prompt:300,400,700&display=swap";
@import "@scss/global.scss";
@import "~bootstrap/scss/bootstrap.scss";
</style>